import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FeedDiv,StyledPopup,PopupWrapper} from './styles';
import SingleFeed from '../SocialFeedsV2/singleFeedForComments';
import { ImageUrl } from '../../utils/constants';
import { CongratulationsEmojiIcon } from '../../utils/icons';
import isEmpty from 'lodash/isEmpty';
// import isNull from 'lodash/isEmpty';
// import connect from 'react-redux/es/connect/connect';
import LazyImage from '../common/LazyImage/LazyImage';
import {connect} from 'react-redux';
import { SliderContainer, RecognitionImage, RecognitionBirthdayAnniversary, UserInitials, RecogntionContainer, WrapImage, MonthlyGoalChallengeCard } from "../SocialFeedsV2/styles";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Waiting from '../Waiting';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { resetCommentsOnPost, setSelectedNotificationPostId } from '../../redux/actions/socialActions';
import { getInitials, getReceiverNameColor, commaSeperator, capitalizeFirstLetter } from '../../utils/methods';
import ShareWorkoutCard from '../LogWorkoutCategoryV2/shareWorkoutCard';
class ViewCommentModal extends Component{

  onClosePopup = ()=>{
    const { location,resetCommentsOnPost, isFromSingleFeed } = this.props;
    if (location.pathname.includes('manager')) {
      this.props.onClose();
    } else {
      this.props.onClose();
      // !isFromSingleFeed && this.props.history.push({pathname:`/social`,state:null});
      !isFromSingleFeed && this.props.setSelectedNotificationPostId(null)
    }
    resetCommentsOnPost();
  }



  hidePopup = (id, value)=>{
    this.props.changeEditDeletePopup(id, value);
    // this.props.onClose();
  }

  containsDefaultPng = (str) => {
    const defaultPngFound = str?.includes("default.png");
    return defaultPngFound;
  }

  getBadgeGradient = (levelName) => {
    const gradients = {
      starter:    'linear-gradient(90deg, #40A075 0%, #54BB8D 51.59%, #40A075 100%)',
      builder:    'linear-gradient(90deg, #987F01 0%, #D5B201 51.59%, #987F01 100%)',
      mover:      'linear-gradient(90deg, #006C8F 0%, #0096C7 51.59%, #006C8F 100%)',
      challenger: 'linear-gradient(90deg, #0040AD 0%, #146BFF 51.59%, #0040AD 100%)',
      elite:      'linear-gradient(90deg, #851600 0%, #D63200 51.59%, #851600 100%)',
    };
    return gradients[(levelName || '').toLowerCase()] || gradients.starter;
  };

  renderMonthlyChallengeFeedLeft = (singleFeedData) => {
    const challenge = singleFeedData?.post_achievement;
    const owner = singleFeedData?.post_owner;
    return (
      <MonthlyGoalChallengeCard style={{ width: '100%', height: '100%', borderRadius: '12px 0 0 12px' }}>
        <img
          className="woliba-logo"
          src={ImageUrl + '/company-logo/ToZRPeButf.png'}
          alt="Woliba"
        />
        <div className="badge-section">
          <LazyImage
            className="badge-img"
            src={`${ImageUrl}/${challenge?.badge?.badge_icon}`}
            alt="badge"
          />
        </div>
        <div className="congrats-text">Congratulations!</div>
        <div className="steps-pill" style={{ background: challenge?.badge?.color }}>
          {commaSeperator(challenge?.total_activity)}{' '}
          {capitalizeFirstLetter(challenge?.activity_type) || 'Steps'}
        </div>
        <div className="achieved-text">Achieved In {challenge?.month_name}</div>
        <div className="stats-row">
          <div className="stat-item">
            <div className="stat-label">Streaks</div>
            <div className="stat-value">{challenge?.longest_streak || 0} {challenge?.longest_streak > 1 ? "Days" :"Day"}</div>
          </div>
          <div className="stat-divider" />
          <div className="stat-item">
            <div className="stat-label">Daily Avg.</div>
            <div className="stat-value">{commaSeperator(challenge?.daily_average || 0)} Steps</div>
          </div>
          <div className="stat-divider" />
          <div className="stat-item">
            <div className="stat-label">XP Earned</div>
            <div className="stat-value">{challenge?.points_earned || 0} XP</div>
          </div>
        </div>
        <div className="challenge-by">A Challenge By Woliba</div>
        <div className="bottom-gradient" style={{ background: this.getBadgeGradient(challenge?.badge?.level_name) }}>
          {owner?.profile_image && !this.containsDefaultPng(owner?.profile_image) ? (
            <div className="owner-avatar-wrapper">
              <img
                src={`${ImageUrl}/${owner?.profile_image}`}
                alt={owner?.post_owner_name}
                onError={(e) => { e.target.src = '/public/images/neutral_avatar.svg'; }}
              />
            </div>
          ) : (
            <div className="owner-initials-wrapper">
              {getInitials(owner?.post_owner_name)}
            </div>
          )}
          <div className="owner-name">{owner?.post_owner_name}</div>
        </div>
      </MonthlyGoalChallengeCard>
    );
  };

  // RIGHT ARROW
  MomentsRightArrow = (props) => {
    const { onClick } = props;
    return (
      <div
        onClick={onClick}
        style={{
          width: "32px",
          height: "32px",
          borderRadius: "50%",
          backgroundColor: "rgba(9, 47, 65, 0.2)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 2,
        }}
      >
        <svg
          width="8"
          height="16"
          viewBox="0 0 8 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.885261 16C0.797538 16.0005 0.710579 15.9837 0.629367 15.9505C0.548156 15.9173 0.474292 15.8685 0.412009 15.8067C0.349534 15.7447 0.299946 15.671 0.266106 15.5898C0.232266 15.5086 0.214844 15.4214 0.214844 15.3334C0.214844 15.2454 0.232266 15.1583 0.266106 15.0771C0.299946 14.9959 0.349534 14.9221 0.412009 14.8602L5.85774 9.41445C6.23221 9.03951 6.44255 8.53127 6.44255 8.00136C6.44255 7.47145 6.23221 6.9632 5.85774 6.58827L0.412009 1.14253C0.286495 1.01702 0.215981 0.846784 0.215981 0.66928C0.215981 0.491776 0.286495 0.321542 0.412009 0.196028C0.537523 0.0705132 0.707757 0 0.885261 0C1.06277 0 1.233 0.0705132 1.35851 0.196028L6.80425 5.64176C7.11462 5.95135 7.36086 6.31912 7.52887 6.72402C7.69689 7.12892 7.78337 7.56298 7.78337 8.00136C7.78337 8.43973 7.69689 8.8738 7.52887 9.2787C7.36086 9.68359 7.11462 10.0514 6.80425 10.361L1.35851 15.8067C1.29623 15.8685 1.22237 15.9173 1.14115 15.9505C1.05994 15.9837 0.972984 16.0005 0.885261 16Z"
            fill="#FFFFFF"
          />
        </svg>
      </div>
    );
  };

  AdminLeftArrowIcon = (props) => {
    const { onClick } = props;
    return (
      <div
        onClick={onClick}
        style={{
          width: "32px",
          height: "32px",
          borderRadius: "50%",
          backgroundColor: "rgba(9, 47, 65, 0.2)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          position: "absolute",
          left: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 2,
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="9"
          height="16"
          viewBox="0 0 9 16"
          fill="none"
        >
          <path
            d="M7.615 16a.666.666 0 0 0 .473-1.14L2.642 9.414a2 2 0 0 1 0-2.826l5.446-5.445a.67.67 0 1 0-.947-.947L1.696 5.642a3.333 3.333 0 0 0 0 4.719l5.445 5.446a.67.67 0 0 0 .474.193"
            fill="#FFFFFF"
          />
        </svg>
      </div>
    );
  };
  
  

  
  


  render(){
    const { showModal, feed, comments, inspirationPost, user, socialFeedReactions, isFlaggedPost, loadingSocialPostDetails } = this.props;
    const singleFeedData= inspirationPost? inspirationPost:feed;
    const multipleImages = singleFeedData?.post_images?.length > 1;
    
    if (isEmpty(singleFeedData) || loadingSocialPostDetails) {
      return <Waiting />
    }
    let socialFeed = {
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      draggable: true,
      adaptiveHeight: true,
      // nextArrow: <img src={ImageUrl+"/social-feed/rightArrow.svg"} style={{width:"24px", height:"24px"}}/>,
      // prevArrow: <img src={ImageUrl+"/social-feed/leftArrow.svg"} style={{width:"24px", height:"24px"}}/>,
      nextArrow: <this.MomentsRightArrow />,
      prevArrow: <this.AdminLeftArrowIcon />,
     
      responsive: [
        {
          breakpoint: 1252,
          settings: {
            dots: true,
            infinite: true,
            speed: 500,
            draggable: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: <this.MomentsRightArrow/>,
            prevArrow: <this.AdminLeftArrowIcon/>,
          },
        },
        {
          breakpoint: 600,
          settings: {
            dots: true,
            infinite: true,
            speed: 500,
            draggable: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
          },
        },
      ],
    };
    const images =(singleFeedData?.post_images?.length ? singleFeedData?.post_images : singleFeedData?.moment_images?.length ? singleFeedData?.moment_images : null);
    return(
      <StyledPopup show={showModal} width={!singleFeedData?.post_images?.length && singleFeedData.type_id === 1 ? "540px !important" : "1200px !important"}>

        <PopupWrapper style={{height:singleFeedData.type_id === 9 && '700px'}} isImageContainer={true} width={!singleFeedData?.post_images?.length && singleFeedData.type_id === 1 ? "100%" : "33.3%"}>
          {!singleFeedData?.post_images?.length && singleFeedData.type_id === 1 ? null : <div className='imageContainer' style={{display:"flex", alignItems:"center",background:singleFeedData.type_id === 7 && 'white'}}>
            {singleFeedData.type_id === 9 ? this.renderMonthlyChallengeFeedLeft(singleFeedData) :
              singleFeedData.type_id === 7 ? <ShareWorkoutCard workoutData={singleFeedData?.post_log_workout} /> :
                singleFeedData?.recognition_recipients?.length>1 || singleFeedData.type_id === 2 || singleFeedData.type_id === 8?
                  <SliderContainer
                    display="flex"
                    content="center"
                    shadow="0px 8px 25px 0px #0D427040"
                    maxHeight
                    style={{margin:"auto"}}
                  >
                    <Slider {...socialFeed}>
                      {singleFeedData.type_id === 2 || singleFeedData.type_id === 8 ?  images?.map((data,index)=>(<WrapImage multipleImages={multipleImages} noMargin key={index} >
                        <img src={`${ImageUrl}/${data.image_url}`} alt={data.body || 'placeholder'}  style={{maxHeight:"600px"}}/>
                      </WrapImage>)) :  singleFeedData?.recognition_recipients.map((data,index)=>(
                        data.recognized_user_name?(singleFeedData.type_id ===4 || singleFeedData.type_id ===5)?
                          <RecognitionBirthdayAnniversary margin image={data?.post_template?.bg_image}  height="568px">
                            <div className='mainContainer'>
                              <div className='wish'>{singleFeedData.type_id ===5?"Happy Work Anniversary!":"Happy Birthday!"}</div>
                              <div className='wish-name'>{data.recognized_user_name}</div>
                              <div className='image'>
                                <div className='imageWidth'>
                                  {data?.profile_image && !this.containsDefaultPng(data?.profile_image)?
                                    <img onError={this.fallBack} src={`${ImageUrl}/${data?.profile_image}`}/>:
                                    <UserInitials color={feed?.post_recognitions?.recognition_color_value}>{getInitials(data?.recognized_user_name)}</UserInitials>}
                                </div>
                              </div>
                              {singleFeedData.type_id ===5?
                                <div className='message'>Your dedication and hard work have been an inspiration to us <br/> all. Here’s to many more years of success together!</div>:
                                <div className='message'>May this year bring you continued success and fulfillment in <br/>both your personal and professional life.</div>}
                            </div>
                          </RecognitionBirthdayAnniversary>:
                          <RecognitionImage margin image={singleFeedData.post_recognitions?.bg_image} key={index}  height="100%">
                            <div className='mainContainer'>
                              <div className='image'>
                                <div className='imageWidth'>
                                  {data?.profile_image && !this.containsDefaultPng(data?.profile_image)?
                                    <img src={`${ImageUrl}/${data?.profile_image}`}/>:
                                    <UserInitials color={feed?.post_recognitions?.recognition_color_value}>{getInitials(data?.recognized_user_name)}</UserInitials>}
                                </div>
                                <RecogntionContainer border={feed?.post_recognitions?.recognition_color_value}>
                                  <div className='recogntionvalue'>
                                    <div className='image'>
                                      <img src={`${ImageUrl}/${singleFeedData?.post_recognitions?.image}`}/>
                                    </div>
                                    <div className='name'>
                                      {singleFeedData?.post_recognitions?.core_value}
                                    </div>
                                  </div>
                                </RecogntionContainer>
                                <div className='recognition'>
                                  <span className='textRecognition'>{"Congratulations to"}</span>
                                  <span className='boldRecognition'>{data?.recognized_user_name}</span>&nbsp;
                                  {CongratulationsEmojiIcon()}
                                </div>
                              </div>
                            </div>
                          </RecognitionImage>:
                          <WrapImage noMargin key={index} >
                            <img src={`${ImageUrl}/${data.profile_image}`} alt={data.body || 'placeholder'}  style={{maxHeight:"600px"}}/>
                          </WrapImage>))}
                    </Slider>
                  </SliderContainer>: 
                  singleFeedData.image  ? 
                    <WrapImage noMargin >
                      <LazyImage src={`${ImageUrl}/${singleFeedData.image}`} alt={singleFeedData.body || 'placeholder'} />
                    </WrapImage>
                    : 
                    singleFeedData.type_id ===4 || singleFeedData.type_id ===5 || singleFeedData.type_id ===3?
                      (singleFeedData.type_id ===4 || singleFeedData.type_id ===5)?
                        <RecognitionBirthdayAnniversary isImageMargin={"141px auto 4px auto"} background margin image={singleFeedData?.post_template?.bg_image}  height="600px">
                          <div className='mainContainer'>
                            {/* <div className='wish'>{singleFeedData.type_id ===5?"Happy Work Anniversary!":"Happy Birthday!"}</div> */}
                            {/* <div className='wish-name'>{singleFeedData?.post_user_wishes[0]?.user_name}</div> */}
                            <div className='image'>
                              <div className='imageWidth'>
                                {singleFeedData?.post_user_wishes[0]?.profile_image && !this.containsDefaultPng(singleFeedData?.post_user_wishes[0]?.profile_image)?<img src={`${ImageUrl}/${singleFeedData?.post_user_wishes[0]?.profile_image}`}/>:
                                  <UserInitials color={feed?.post_recognitions?.recognition_color_value}>{getInitials(singleFeedData?.post_user_wishes[0]?.user_name)}</UserInitials>}
                              </div>
                            </div>
                            <div   style={{color: getReceiverNameColor(singleFeedData?.type_id, singleFeedData?.post_template_id)}} className='wish-name'>{singleFeedData?.post_user_wishes[0]?.user_name}</div>
                            
                            {/* {singleFeedData.type_id ===5?
                              <div className='message'>Your dedication and hard work have been an inspiration to us <br/> all. Here’s to many more years of success together!</div>:
                              <div className='message'>May this year feeee bring you continued success and fulfillment in <br/>both your personal and professional life.</div>} */}
                          </div>
                        </RecognitionBirthdayAnniversary>
                        :<RecognitionImage margin image={singleFeedData?.post_recognitions?.bg_image}  height="600px" background="100% " style={{borderRadius:'12px 0 0 12px'}}>
                          <div className='mainContainer'>
                            <div className='image'>
                              <div className='imageWidth'>
                                {singleFeedData?.recognition_recipients?.[0]?.profile_image && !this.containsDefaultPng(singleFeedData?.recognition_recipients?.[0]?.profile_image)?<img src={`${ImageUrl}/${singleFeedData?.recognition_recipients?.[0]?.profile_image}`}/>:
                                  <UserInitials  isFont={"64px"} color={"#092F41"}>{getInitials(singleFeedData?.recognition_recipients?.[0]?.recognized_user_name)}</UserInitials>}
                              </div>
                              <RecogntionContainer border={feed?.post_recognitions?.recognition_color_value}>
                                <div className='recogntionvalue'>
                                  <div className='image'>
                                    <img src={`${ImageUrl}/${singleFeedData?.post_recognitions?.image}`}/>
                                  </div>
                                  <div className='name'>
                                    {singleFeedData?.post_recognitions?.core_value}
                                  </div>
                                </div>
                              </RecogntionContainer>
                              <div className='recognition'>
                                <span className='textRecognition'>{"Congratulations to"}</span>
                                <span className='boldRecognition'>{singleFeedData?.recognition_recipients?.[0]?.recognized_user_name}</span>&nbsp;
                                {CongratulationsEmojiIcon()}
                              </div>
                            </div>
                          </div>
                        </RecognitionImage>:null}
          </div>}
          <div className='commentsContainer'>
            <FeedDiv widthValue={singleFeedData.image? true : true} radius={ !singleFeedData?.post_images?.length && singleFeedData.type_id === 1 }>
              <SingleFeed
                feed={singleFeedData}
                description={singleFeedData.text}
                taggedUsers={singleFeedData.shoutout_user_name}
                getCommentsForPost={this.props.getCommentsForPost}
                changeEditDeletePopup={this.hidePopup}
                editAndDelete = {this.props.editAndDelete}
                openEditAndDelete={this.props.openEditAndDelete}
                profileImage={this.props.profileImage}
                updationList="response"
                commentCount={singleFeedData.comment_count}
                history={this.props.history}
                enableTrigger={this.props.enableTrigger}
                // key={`feed-${index}-${feed.id}`}
                onChange={this.props.onChange}
                handleFeed={this.props.handleFeed}
                handleModal = {this.props.handleModal}
                feedNumber={this.props.feedNumber}
                data = {this.props.data}
                exemplifiesValues = {this.props.exemplifiesValues}
                showRecognition = {this.props.showRecognition}
                value = {this.props.value}
                id = {this.props.id}
                image = {this.props.image}
                feedNo = {this.props.feedNo}
                updateFeedsLike={this.props.updateFeedsLike}
                storedFeeds={this.props.storedFeeds}
                editPost={this.props.editPost}
                socialCallBack={this.props.socialCallBack}
                handlePhotoPostModal={this.props.handlePhotoPostModal}
                hideCommentText = {false}
                hideValuesInCommentsModel={true}
                comments={comments}
                postReply={this.props.postReply}
                replySuccess={this.props.replySuccess}
                commentId={singleFeedData.id}
                closeCommentPoup={this.props.onClose}
                isCommentModal={true}
                onClosePopup={this.onClosePopup}
                user={user}
                defaultReactions={socialFeedReactions}
                isFlaggedPost={isFlaggedPost}
                privacyPopupHandle={this.props.privacyPopupHandle}
                likeUnlikeSingleFeedPost={this.props.likeUnlikeSingleFeedPost}
                handleReactionSingleFeedPost={this.props.handleReactionSingleFeedPost}
                isFromSingleFeed={this.props.isFromSingleFeed}
                // feedLikeStatus={this.props.feedLikeStatus}
                // likedType={this.props.likedType}
              />
            </FeedDiv>
          </div>
        </PopupWrapper>
      </StyledPopup>
    )
  }
}

ViewCommentModal.propTypes =  {
  showModal: PropTypes.bool,
  onClose: PropTypes.func,
  feed: PropTypes.object.isRequired,
  description: PropTypes.string,
  taggedUsers: PropTypes.string,
  getCommentsForPost: PropTypes.func.isRequired,
  changeEditDeletePopup: PropTypes.func.isRequired,
  editAndDelete: PropTypes.bool.isRequired,
  openEditAndDelete: PropTypes.func.isRequired,
  profileImage: PropTypes.string,
  updationList: PropTypes.string,
  commentCount: PropTypes.number,
  history: PropTypes.object,
  enableTrigger: PropTypes.bool,
  onChange: PropTypes.func,
  handleFeed: PropTypes.func,
  handleModal: PropTypes.func.isRequired,
  feedNumber : PropTypes.number,
  data: PropTypes.array.isRequired,
  exemplifiesValues : PropTypes.array,
  showRecognition : PropTypes.func,
  value : PropTypes.string,
  id : PropTypes.number,
  image : PropTypes.string,
  feedNo : PropTypes.number,
  updateFeedsLike: PropTypes.func,
  editPost: PropTypes.func,
  storedFeeds: PropTypes.array,
  socialCallBack: PropTypes.func,
  handlePhotoPostModal: PropTypes.func,
  postReplyOnComment: PropTypes.func.isRequired,
  comments: PropTypes.array,
  postReply: PropTypes.func,
  replySuccess: PropTypes.string,
  inspirationPost: PropTypes.array,
  t: PropTypes.func,
  user: PropTypes.object,
  location: PropTypes.object.isRequired,
  resetCommentsOnPost:PropTypes.func,
  defaultReactions:PropTypes.object,
  isFlaggedPost:PropTypes.bool,
  privacyPopupHandle:PropTypes.func,
  isFromSingleFeed:PropTypes.bool,
  setSelectedNotificationPostId:PropTypes.number,
  likeUnlikeSingleFeedPost:PropTypes.func,
  handleReactionSingleFeedPost:PropTypes.func,
  feedLikeStatus:PropTypes.bool,
  likedType: PropTypes.string,
  socialFeedReactions:PropTypes.object,
  loadingSocialPostDetails:PropTypes.bool
};

const mapStateToProps = (state) => ({
  inspirationPost: state.social.inspirationPost,
  socialFeedReactions:state.social.socialFeedReactions,
  loadingSocialPostDetails:state.social.loadingSocialPostDetails
});

const mapDispatchToProps = (dispatch) => ({
  resetCommentsOnPost: () => dispatch(resetCommentsOnPost()),
  setSelectedNotificationPostId:(id)=> dispatch(setSelectedNotificationPostId(id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(ViewCommentModal)));